import { Controller } from "@hotwired/stimulus"
import { subscribeToMarketPrices } from "../channels/market_prices_channel"

export default class extends Controller {
  static targets = ["yesProb", "noProb", "yesBar", "noBar"]
  static values = { marketId: String }

  connect() {
    if (!this.marketIdValue) return

    this.subscription = subscribeToMarketPrices(this.marketIdValue, {
      received: (data) => this.updatePrices(data)
    })
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  updatePrices(data) {
    const yesPercent = (data.probability_yes * 100).toFixed(1)
    const noPercent = (data.probability_no * 100).toFixed(1)

    if (this.hasYesProbTarget) this.yesProbTarget.textContent = `${yesPercent}%`
    if (this.hasNoProbTarget) this.noProbTarget.textContent = `${noPercent}%`
    if (this.hasYesBarTarget) this.yesBarTarget.style.width = `${yesPercent}%`
    if (this.hasNoBarTarget) this.noBarTarget.style.width = `${noPercent}%`

    window.dispatchEvent(new CustomEvent("mulatrade:prices-changed", {
      detail: { probability_yes: data.probability_yes, probability_no: data.probability_no }
    }))
  }
}
